export enum ReservationTypeEnum {
    Query = 'Query',
    RealTime = 'RealTime',
}
